import { default as DatetimePickerModule, DatetimePickerTypeEnum } from "./datetimepickerModule";

export { DatetimePickerModule, DatetimePickerTypeEnum };
